import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
padding:0px 30px;
  display: flex;
  justify-content: center;
  align-items: center;
box-sizing:border-box;
  flex-direction: column;
  h2{
font-size: 26px;
    color: #000;
    margin: 0px 0px 30px 0px;
  }
  p{
    font-size:18px;
  color:#464545;
  text-align:center;
      margin-bottom: 5px;
  }
  img{
  margin:20px 0px;
  }
  button{
  min-width: 160px;
    height: 48px;
    font-size: 16px;
    background:#EE3140;
    border: 1px solid #EE3140;
    border-radius: 6px;
    color: #fff;
  }
`
